import React from 'react';
import { FadeIn } from './FadeIn';
import { useContactModal } from './ContactModalContext';
export const FinalCTA = () => {
  const {
    openModal
  } = useContactModal();
  return <section className="py-32 bg-navy text-center px-6 relative overflow-hidden" data-id="element-93">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-sage opacity-10 rounded-full blur-3xl pointer-events-none" data-id="element-94" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-95">
        <FadeIn data-id="element-96">
          <h2 className="font-serif text-3xl md:text-5xl text-white mb-8 leading-tight" data-id="element-97">
            Решение об операции — одно из важнейших в жизни.
          </h2>
          <p className="text-xl text-white/70 mb-12" data-id="element-98">
            Не принимайте его в спешке. <br className="hidden md:block" data-id="element-99" />
            48 часов — и у вас будет независимая экспертная оценка для разговора
            с лечащим врачом.
          </p>
          <button onClick={() => openModal('manager')} className="bg-sage hover:bg-sageLight hover:text-navy text-white px-10 py-5 rounded-full font-medium text-lg transition-all duration-300" data-id="element-100">
            Пообщаться с менеджером
          </button>
        </FadeIn>
      </div>
    </section>;
};